import { Box, Button, Fade, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useGetPlateAreaChart } from "../../../Production/OrderArchive/Hook";
import TotalChart from "./../TotalChart";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import TabChartFilter from "../components/TabChartFilter";
import YearsDrop from "../components/YearsDrop";
import moment from "moment-jalaali";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import TitleChart from "../components/TitleChart";
import FilterKilscheTypeAndThicknes from "../SellingPrice/FilterKilscheTypeAndThicknes";
import { FilterIcon } from "lucide-react";
import FilterHandler from "../components/FilterHandler";

function ProductionChart() {
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };
  const theme = useTheme().palette.mode;

  const currentJalaliYear = moment().locale("en").format("jYYYY");

  const [year, setYear] = useState({ year: currentJalaliYear });
  const [month, setMonth] = useState(0);
  const [KlischeType, setKlischeType] = useState({
    KlischeType: "00000000-0000-0000-0000-000000000000",
  });
  const [KilscheThicknes, setKilscheThicknes] = useState({
    KilscheThicknes: "00000000-0000-0000-0000-000000000000",
  });
  const [dataLineChart, setDataLineChart] = useState([]);
  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const { mutate, data } = useGetPlateAreaChart(Number(currentJalaliYear));

  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
          ? { name: "mondth", enum: 1 }
          : { name: "year", enum: 2 },
    );
  };
  //*total count state
  const [total, setTotal] = useState([]);
  //re-render
  useEffect(() => {
    mutate({
      chartReportTiming: chartFilter.enum,
      year: chartFilter.enum === 1 ? year.year : year.year,
      month: month.month,
      klischeTypeId: KlischeType.KlischeType,
      klischeThicknessId: KilscheThicknes.KilscheThicknes,
    });
  }, [chartFilter, year, KlischeType, KilscheThicknes]);
  useEffect(() => {
    if (data) {
      setDataLineChart(data?.data?.data.items);
      setTotal([
        {
          count: data?.data?.data?.total,
          color: "#3592FB",
          title: "مساحت پلیت",
          key: "total_1_1",
        },
        {
          count: data?.data?.data?.total1,
          color: "rgba(212, 22, 79, 1)",
          title: "مساحت پرتی",
          key: "total_1_2",
        },
        {
          count: data?.data?.data?.total2,
          color: "rgba(76, 175, 80, 1)",
          title: "درصد  پرتی",
          key: "total_1_3",
        },
      ]);
    }
  }, [data]);
  useEffect(() => {
    setKilscheThicknes({
      KilscheThicknes: "00000000-0000-0000-0000-000000000000",
    });
    setKlischeType({ KlischeType: "00000000-0000-0000-0000-000000000000" });
  }, [chartFilter]);

  const deviceType = useDeviceType();
  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "productionChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);

  return (
    <>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                width: "70%",
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
                overflowX: "auto",
              }}
            ></Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "40%",
                display: "flex",
                justifyContent: "flex-start",
                minWidth: 200,
              }}
            >
              <TitleChart label={"تولید"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                />
              </Box>
              <FilterHandler filter={filter} setFilter={setFilter} />
            </Box>
          </Box>
          {filter && (
            <Fade in={filter} timeout={300}>
              <Box
                sx={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  padding: "8px",
                  backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                }}
              >
                <FilterKilscheTypeAndThicknes
                  KlischeType={KlischeType}
                  setKlischeType={setKlischeType}
                  KilscheThicknes={KilscheThicknes}
                  setKilscheThicknes={setKilscheThicknes}
                  chartFilter={chartFilter}
                  year={year}
                  setYear={setYear}
                  month={month}
                  setMonth={setMonth}
                />
              </Box>
            </Fade>
          )}

          <Box sx={{ width: "100%", height: "18rem" }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width={"auto"}
                height={"17.5rem"}
                data={dataLineChart}
                margin={{
                  top: 5,
                  right: 5,
                  left: deviceType === "mobile" ? -10 : 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  fontSize={"10px"}
                  angle={0}
                  tickMargin={5}
                  tickFormatter={(value) => toPersianDigits(value)}
                />
                <YAxis
                  fontSize={deviceType === "mobile" ? "11px" : "14px"}
                  tickMargin={deviceType === "mobile" ? 30 : 50}
                  tickFormatter={(value) => toPersianDigits(value)}
                />
                <Tooltip
                  cursor={false}
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      const data = payload[0].payload;
                      return (
                        <div
                          style={{
                            background: "#fff",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                          }}
                        >
                          <Typography
                            color={"#3592FB"}
                          >{` مساحت پلیت: ${toPersianDigits(data.value)}`}</Typography>
                          <Typography
                            color={"#ff0000ab"}
                          >{`مساحت پرتی: ${toPersianDigits(data.value1)}`}</Typography>
                          <Typography
                            color={"rgba(76, 175, 80, 1)"}
                          >{`درصد پرتی: ${toPersianDigits(data.value2)}`}</Typography>
                        </div>
                      );
                    }
                    return null;
                  }}
                />
                <Line
                  type="monotone"
                  name="مساحت پلیت ها"
                  dataKey="value"
                  stroke="#3592FB"
                  activeDot={{ r: 8 }}
                />
                <Line
                  type="monotone"
                  name="مساحت  پرتی"
                  dataKey="value1"
                  stroke="rgba(212, 22, 79, 1)"
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
          <Box display={"flex"}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              {deviceType != "mobile" && <TotalChart total={total} />}
            </Box>
          </Box>
        </>
      ): <Box
              sx={{
                flexGrow: 1,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minWidth: 200,
              }}
            >
              <TitleChart label={"تولید"} chartKey={chartKey} />
            </Box>}
    </>
  );
}

export default ProductionChart;
